module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blog-page"
  }, [_c('div', {
    staticClass: "intro"
  }, [_c('div', {
    staticClass: "intro-container"
  }, [_c('h1', {
    ref: "title",
    staticClass: "intro__heading h1-like"
  }, [_vm._v(_vm._s(_vm.$content.title))]), _c('p', {
    ref: "subtitle",
    staticClass: "intro__description"
  }, [_vm._v(_vm._s(_vm.$content.description))])]), _c('transition-wrapper', {
    attrs: {
      "appear": true
    }
  }, [_c('scroll-marker', {
    staticClass: "intro__scroll",
    attrs: {
      "dark-mode": true
    },
    on: {
      "click": _vm.scroll
    }
  })], 1)], 1), _c('transition-wrapper', {
    attrs: {
      "appear": true
    }
  }, [_c('list', {
    ref: "list",
    attrs: {
      "type": "news",
      "items": _vm.items,
      "count": _vm.count
    },
    on: {
      "load-more-items": _vm.loadMore
    }
  })], 1), _c('the-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06d5d17f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/list/news.vue
// module id = 464
// module chunks = 0